export const isBlank = (s: string | null | undefined): boolean => !s || !s.trim();
export const isNotBlank = (s: string | null | undefined): s is string => !isBlank(s);
export const removeExtraSpaces = (s: string): string => s.replace(/^ +| +$|( ) +/g, "$1");
export const removeAllSpaces = (s: string): string => s.replace(/ /g, "");
export const removeAllWhitespace = (s: string): string => s.replace(/\s/g, "");
export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
export const uncapitalize = (s: string) => s.charAt(0).toLowerCase() + s.slice(1);
export const unblank = (s: string): string | undefined => (isBlank(s) ? undefined : s);
export const extractFirstUUID = (s: string): string | undefined => /(\w{4,12}-?){5}/.exec(s)?.[0];
